import { createAction, props } from '@ngrx/store';
import { TenantDto } from '../api/core';
import { TenantActionTypes } from './tenants.models';

export const loading = createAction(TenantActionTypes.LOADING);
export const loadingDone = createAction(TenantActionTypes.LOADING_DONE);
export const loadTenants = createAction(TenantActionTypes.LOAD_TENANTS);
export const loadedTenants = createAction(TenantActionTypes.LOADED_TENANTS, props<{ data: TenantDto[] }>());
export const loadTenantDetails = createAction(TenantActionTypes.LOAD_TENANT_DETAILS, props<{ keycloakId: string }>());
export const loadedTenantDetails = createAction(
    TenantActionTypes.LOADED_TENANT_DETAILS,
    props<{ tenant: TenantDto; keycloakId: string }>()
);

export const createTenant = createAction(TenantActionTypes.CREATE_TENANT, props<{ tenant: TenantDto }>());
export const createdTenant = createAction(TenantActionTypes.CREATED_TENANT, props<{ tenant: TenantDto }>());
export const updateTenant = createAction(TenantActionTypes.UPDATE_TENANT, props<{ tenant: TenantDto }>());
export const updatedTenant = createAction(TenantActionTypes.UPDATED_TENANT, props<{ tenant: TenantDto }>());
export const deleteTenant = createAction(TenantActionTypes.DELETE_TENANT, props<{ id: string }>());
export const deletedTenant = createAction(TenantActionTypes.DELETED_TENANT, props<{ id: string }>());
